// extracted by mini-css-extract-plugin
module.exports = {"root":"_1_kgq","buttonsContainer":"_3KTju","button":"_2219U","header":"_3jyNh"};